import { render, staticRenderFns } from "./environment.vue?vue&type=template&id=c423968c"
import script from "./environment.vue?vue&type=script&lang=ts"
export * from "./environment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports